export const getNormalizedCanvasDimensions = (
  canvas: HTMLCanvasElement,
  scale: number,
): [number, number] => {
  return [canvas.width / scale, canvas.height / scale];
};
